<div style="margin: 10px;">

	<prtg-export-config [Network]="network" [PrtgExport]="prtgExport"
						[EnableExportOrigin]="false"></prtg-export-config>

</div>

